import { OrderStatus, OrderType } from '@api/types';
import { Box, BoxProps, styled } from '@mui/material';

const StyledBox = styled(Box)`
  display: inline-flex;
  align-items: center;
`;

const Light = styled(Box)`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 12px;
  // TODO [KF][KL] - we need a complete list of statuses and colors
  background: #000;
  &.placed {
    background: #16a257;
  }
  &.processing {
    background: #fff3d3;
  }
  &.delivering {
    background: #deede5;
  }
  &.delivered {
    background: #4d4d4d;
    color: #ffffff;
  }
  &.draft {
    background: #b4b9bb;
  }
  &.postponedelivery {
    background: #b6cfe1;
  }
`;

export type StatusLightProps = BoxProps & {
  status?: OrderStatus | OrderType;
};

export const StatusLight = ({ children, status, ...rest }: StatusLightProps) => {
  return (
    <StyledBox {...rest} component='span' className={status?.toLowerCase()}>
      <Light className={status?.toLowerCase()} />
      {children}
    </StyledBox>
  );
};
